import moment from 'moment';

function Ctrl($scope, $state, $stateParams, imgix, modalService) {
  $scope.modified = function(item) {
    if (!item || !item.modified) return false;

    const modified = moment(item.modified);

    return moment().diff(modified, 'hours') < 48;
  };

  $scope.goToItem = function(item) {
    if ($scope.isPreview) {
      return modalService.getMembership();
    }

    if (item.type === 'EVENT') {
      $state.go('app.event', {
        seoPathname: item.contentSeoPathname || item.event.id,
        back: $stateParams.id
      });
    }

    if (item.type === 'VENUE') {
      $state.go('app.venue', {
        seoPathname: item.contentSeoPathname || item.venue.id,
        back: $stateParams.id
      });
    }

    return null;
  };

  $scope.eventDateString = function(event) {
    if (!event || !event.date) return null;

    const eventDate = moment.utc(event.date).startOf('day');

    $scope.date = eventDate;

    const now = moment.utc();

    const today = now.clone().startOf('day');
    const tomorrow = now.clone().add(1, 'days').startOf('day');

    if ($scope.isPast()) {
      return `${eventDate.format('M/D/YYYY')} at `;
    }

    if (eventDate.isSame(today, 'd')) {
      return `Tonight, ${eventDate.format('M/D')} at `;
    }

    if (eventDate.isSame(tomorrow, 'd')) {
      return `Tomorrow, ${eventDate.format('M/D')} at `;
    }

    return `${eventDate.format('dddd, M/D')} at `;
  };

  $scope.isPast = function() {
    if (!$scope.event) return false;

    const start = moment($scope.event.date, 'x');
    const now = moment();
    const diff = now.diff(start, 'hours');

    return (diff >= 24);
  };

  $scope.imgix = function(src) {
    const options = {
      width: 270
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'jsSdk.imgix',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/curatedListEventCard/controller.js